<template>
  <div id="listWidget" class="mb-4" style="padding-bottom: 2rem;">
    <ul class="breadcrumb">
      <li class="breadcrumb-item">{{ zone?.name }}</li>
      <li class="breadcrumb-item active">방(그룹) 관리</li>
    </ul>
    
    <div>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <!-- <h4 class="mb-0">방 관리</h4> -->
        <button 
          type="button" 
          :class="`btn ${sortMode ? 'btn-primary' : 'btn-outline-primary'}`" 
          style="padding: 0.375rem 0.75rem; font-size: 0.875rem;"
          @click="onSortModeClick"
        >
          <i :class="`fa-solid ${sortMode ? 'fa-times' : 'fa-arrows-up-down'} me-1`"></i>
          {{ sortMode ? "정렬모드 끄기" : "정렬모드 켜기" }}
        </button>
      </div>

      <!-- 방 관리 안내 -->
      <div class="instruction-card card-item mb-3">
        <div class="instruction-body">
          <div class="instruction-step">
            <div class="step-content">
              <span>아래 <strong class="text-primary">그룹 버튼</strong>을 누르시면 해당 그룹이 추가 됩니다.</span>
            </div>
          </div>
          <div class="instruction-step">
            <div class="step-content">
              <span>정렬모드가 켜지면 방 순서를 변경할 수 있습니다.</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 방 선택 카드 -->
      <div class="group-select-card card-item mb-3">
        <div class="group-select-card-header">
          <i class="fa-brands fa-microsoft me-2 text-primary"></i>
          <span class="group-select-card-title">방(그룹) 추가</span>
        </div>
        <div class="group-select-card-body">
          <button
            type="button"
            :class="`btn ${sortMode ? 'btn-outline-secondary' : 'btn-outline-primary'} group-select-btn`"
            v-for="(item, index) in templateGroupNames"
            :key="index"
            @click="onAddGroupClick(item)"
            :disabled="sortMode"
          >
            {{ item }}
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <VueDraggable 
        ref="dragableRef" 
        v-model="groups"
        animation="150"
        :disabled="!sortMode"
        @choose="onSortChoose"
        @end="onSortEnd"
        @update="onSortUpdate"
        filter=".fixed"
        style="padding: 0px;"
      >
        <GroupItem
          v-for="(item, index) in groups"
          :key="item._id"
          :index="index"
          :data="item"
          :sort="sortMode"
          @onDeleteClick="onDeleteGroupClick"
          @onGroupUpdated="onGroupUpdated"
        />
      </VueDraggable>
    </div>

    <PopDialog
      title="방추가"
      :visible="addGroupModal.visible"
      :okCallback="onAddGroupConfirmClick"
      :cancelCallback="addGroupModal.hide"
    >
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        placeholder="방 이름을 입력해주세요."
        v-model="addGroupName"
      />
    </PopDialog>

    <PopDialog
      title="조명제어기 추가"
      :visible="addControllerModal.visible"
      :okCallback="onAddControllerConfirmClick"
      :cancelCallback="addControllerModal.hide"
    >
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        placeholder="조명제어기 시리얼넘버를 입력해주세요."
        v-model="addController._id"
      />
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        placeholder="조명제어기 모델명을 입력해주세요."
        v-model="addController.model"
      />
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        placeholder="조명제어기 macAddress를 입력해주세요."
        v-model="addController.macAddress"
      />
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        placeholder="조명제어기 firmware 입력해주세요."
        v-model="addController.firmwareVersion"
      />
    </PopDialog>
  </div>
</template>

<style scoped>
/* instruction-card 스타일 */
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.instruction-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.instruction-step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  position: relative;
  padding-left: 1rem;
}

.instruction-step::before {
  content: '•';
  position: absolute;
  left: 0;
  top: 0.15rem;
  color: #6c757d;
  font-size: 1.25rem;
  line-height: 1;
}

.instruction-step:last-child {
  margin-bottom: 0;
}

.step-number {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.75rem;
}

.step-content {
  flex: 1;
  padding-top: 0.1rem;
  font-size: 0.85rem;
  line-height: 1.6;
  color: #495057;
}

.step-content strong {
  color: #0d6efd;
  font-weight: 600;
}

/* group-select-card 스타일 */
.group-select-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.group-select-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.group-select-card-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.group-select-card-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.group-select-card-body {
  padding: 1rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
}

.group-select-btn {
  font-size: 0.875rem;
  padding: 0.5rem 0.75rem;
  transition: all 0.2s ease;
  width: 100%;
}

.group-select-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.group-select-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 등록된 방 카드 영역 마진 정렬 */
#listWidget > .row {
  margin-left: 0;
  margin-right: 0;
}

#listWidget > .row .col-md-6 {
  padding-left: 0;
  padding-right: 0;
}

/* 모바일 반응형 간격 조정 */
@media (max-width: 768px) {
  #listWidget {
    margin-bottom: 1rem;
    padding-bottom: 2rem;
  }

  .instruction-card,
  .group-select-card {
    margin-bottom: 1rem;
  }

  .group-select-card-body {
    grid-template-columns: repeat(4, 1fr);
  }

  .group-select-btn {
    font-size: 0.8rem;
    padding: 0.4rem 0.5rem;
  }
}
</style>

<script setup>
import {
  ref,
  reactive,
  getCurrentInstance,
  onBeforeMount,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
} from 'vue';
import { useStore } from 'vuex';
import Axios, { ZoneApi, GroupApi, CtrlApi } from '@/api';
import { useRouter, useRoute ,onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';
import PopDialog from '@/common/components/popup/PopDialog.vue';
import useModal from '@/common/hooks/useModal';
import GroupItem from './components/GroupItem.vue';
import { Template } from '@/common/constants';
import useMqttControl from '@/common/hooks/useMqttControl';
import { VueDraggable } from 'vue-draggable-plus';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';

const mqttControl = reactive(useMqttControl());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const router = useRouter();
const route = useRoute();
const props = defineProps(['data']);
const zone = ref(undefined);
const addGroupName = ref('');
const addController = ref({
  _id: '',
  model: '',
  macAddress: '',
  firmwareVersion: '',
});
const addGroupModal = reactive(useModal());
const addControllerModal = reactive(useModal());
const store = useStore();
const forceRoute = ref(false);
const dragableRef = ref();
const templateGroupNames = ref(Template.GroupNames);
const groups = computed(() => {
  return zone.value?.groups?.sort((a, b) => {
    if (a.sort && !b.sort) return -1;
    if (!a.sort && b.sort) return 1;
    if (!a.sort && !b.sort) return 0;
    if (a.sort > b.sort) return 1;
    if (a.sort < b.sort) return -1;
    return 0;
  }) || [];
});
const sortMode = ref(false);

onBeforeMount(() => {
  emitter.emit('onChangeHeaderSetting',{title:'방(그룹) 관리',isShowMenu:false,isShowZone:false,isShowProfile:false,isShowRightHome:true});  
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true,isShowRightHome:false});
})
onMounted(() => {
  requestZone();
  console.log('GroupSettingPage.onMounted => zone : ', zone.value);
});

watch(zone, () => {
  console.log('GroupSettingPage.watch => zone : ', zone.value);
});

onBeforeRouteLeave(async(to, from) => {
  // 등록/설정 페이지로 이동할 때만 체크
  const isControllerPage = to.path === '/settings/light/controllers' 
    || to.path?.includes('/regist-controller')
    || to.path?.includes('/setting-controllers')
    || to.path?.includes('/regist-controllers');
  
  if(isControllerPage){
    if(forceRoute.value)return true;

    emitter.emit('showPopAlert', {
      description:
        '세팅모드를 종료하시겠습니까?',
        okCallback:async() =>{
          forceRoute.value = true;
          const payload = {isEditMode:false}
          const result = await Axios.patch(
            ZoneApi.UPDATE_ZONE.replace(':id', zone.value._id),
            payload,
          );

          if (result.resultCode === '0000') {
            mqttControl.onPublishZone(zone.value._id,payload)
            store.dispatch('home/fetchAllZones');
            router.go(-1)              
          }
        },
        cancelCallback:() =>{}
    });
    return false;
  }
  return true;
});

const onSortChoose = (e) => {
  e.item.classList.remove("shake");
}

const onSortEnd = (e) => {
  e.item.classList.add("shake");
}

const onSortUpdate = async (e) => {
  let sortedGroups = groups.value;
  const insertIndex = e.oldIndex < e.newIndex ? e.newIndex + 1 : e.newIndex;
  const removeIndex = e.oldIndex < e.newIndex ? e.oldIndex : e.oldIndex + 1;
  sortedGroups.splice(insertIndex, 0, groups.value[e.oldIndex]);
  sortedGroups.splice(removeIndex, 1);

  sortedGroups = sortedGroups.map((group, index) => ({
    ...group,
    sort: index + 1
  }));
  zone.value.groups = sortedGroups;
  store.commit('home/updateZone', { data: { groups: sortedGroups } });

  const groupIds = sortedGroups.map(group => group._id);
  await requestSortUpdate(groupIds);
}

const onAddGroupClick = (name) => {
  if (sortMode.value) { 
    return;
  }

  if (name === Template.GroupNames[Template.GroupNames.length - 1]) {
    addGroupModal.show();
    return;
  }
  requestAddGroup({ zoneId: route.params.zoneId, groupName: name });
};
const onAddGroupConfirmClick = () => {
  console.log(addGroupName.value);
  if (addGroupName.value.length === 0) {
    emitter.emit('showPopAlert', {
      description: "방 이름을 입력해주세요.",
    });
    return;
  }

  addGroupModal.hide();
  requestAddGroup({ zoneId: route.params.zoneId, groupName: addGroupName.value });
};
const onAddControllerConfirmClick = () => {
  console.log(addController.value);
  requestAddController({
    zoneId: route.params.zoneId,
    controller: addController.value,
  });
};

const onDeleteGroupClick = (payload) => {
  // console.log('GroupSettingPage.onDeleteZoneClick => payload :', payload);

  let devices = zone.value.groups.find((g) => g._id == payload.groupId).devices;
  if (devices.length > 0) {
    emitter.emit('showPopConfirm', {
      description: '단말정보가 포함된 방입니다.\n정말 삭제하시겠습니까?',
      okCallback: async () => {
        try {
          await requestDeleteGroup(payload.groupId);
          emitter.emit('showPopAlert', {
            description: '방이 삭제되었습니다.',
          });
        } catch (e) {
          emitter.emit('showPopAlert', {
            description: e,
          });
        }
      },
      cancelCallback: () => {},
    });
    return;
  }
  requestDeleteGroup(payload.groupId);
};

const onGroupUpdated = () => {
  requestZone();
};

const requestZone = async () => {
  try {
    const result = await Axios.get(
      ZoneApi.ZONE_INFO.replace(':id', route.params.zoneId),
    );
    if (result.resultCode === '0000') {
      zone.value = result.resultData;
    } else {
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
  } catch (error) {
    // emitter.emit('showPopAlert', {
    //   description: '영역 조회에 실패했습니다.',
    // });
  }
};

const requestAddController = async (payload) => {
  try {
    const result = await Axios.post(
      ZoneApi.REGIST_ZONE_CTRLS.replace(':id', payload.zoneId),
      payload.controller,
    );
    if (result.resultCode === '0000') {
      requestZone();
      return;
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
  } catch (e) {
    console.log(e);
    emitter.emit('showPopAlert', {
      description: '방 추가중 오류가 발생하였습니다.',
    });
  }
};

const requestAddGroup = async (payload) => {
  try {
    const result = await Axios.post(
      ZoneApi.REGIST_ZONE_GROUPS.replace(':id', payload.zoneId),
      { name: payload.groupName },
    );
    if (result.resultCode === '0000') {
      requestZone();
      store.commit('home/addGroup', {
        zoneId: route.params.zoneId,
        data: result.resultData.group,
      });
      return;
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
  } catch (e) {
    console.log(e);
    emitter.emit('showPopAlert', {
      description: '방 추가중 오류가 발생하였습니다.',
    });
  }
};
const requestDeleteGroup = async (groupId) => {
  try {
    const result = await Axios.delete(GroupApi.DELETE_GROUP.replace(':id', groupId));
    if (result.resultCode === '0000') {
      requestZone();
      store.commit('home/deleteGroup', {
        zoneId: route.params.zoneId,
        groupId: groupId,
      });
      return;
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '방 삭제중 오류가 발생하였습니다.',
    });
  }
};

const requestSortUpdate = async (groupIds) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.patch(GroupApi.UPDATE_SORT, { groupIds });
      if (result.resultCode === '0000') {
        resolve(result);
      } else {
        reject(result.resultMessage);
      }
    } catch (error) {
      reject(error);
    }
  });
}

const onSortModeClick = () => {
  sortMode.value = !sortMode.value;
}
</script>
